import { z } from 'zod';
export const InquiryCategorySchema = z.enum(['product', 'license']);
export const InquiryStatusSchema = z.enum(['open', 'closed']);
export const InquiryMessageSchema = z.object({
    id: z.string().uuid(),
    inquiryId: z.string().uuid(),
    authorType: z.enum(['admin', 'customer']),
    authorName: z.string(),
    body: z.string(),
    createdAt: z.string().datetime(),
});
export const InquirySchema = z.object({
    id: z.string().uuid(),
    customerId: z.string().uuid(),
    customerName: z.string().optional(),
    openerCustomerUserId: z.string().uuid(),
    openerName: z.string().optional(),
    category: InquiryCategorySchema,
    subject: z.string(),
    status: InquiryStatusSchema,
    lastMessageAt: z.string().datetime(),
    createdAt: z.string().datetime(),
    messageCount: z.number().int().optional(),
});
export const CreateInquiryRequestSchema = z.object({
    category: InquiryCategorySchema,
    subject: z.string().min(1).max(200),
    body: z.string().min(1).max(10000),
});
export const AddInquiryMessageRequestSchema = z.object({
    body: z.string().min(1).max(10000),
});
//# sourceMappingURL=inquiry.js.map